//----------------------
// <auto-generated>
//     Generated using the NSwag toolchain v13.19.0.0 (NJsonSchema v11.0.0.0 (Newtonsoft.Json v13.0.0.0)) (http://NSwag.org)
// </auto-generated>
//----------------------

/* tslint:disable */
/* eslint-disable */
// ReSharper disable InconsistentNaming
import * as Types from '../api-client';
import { useQuery, useMutation } from '@tanstack/react-query';
import type { UseQueryResult, QueryFunctionContext, UseQueryOptions, QueryClient, QueryKey, MutationKey, UseMutationOptions, UseMutationResult, QueryMeta, MutationMeta } from '@tanstack/react-query';
import { trimArrayEnd, isParameterObject, getBaseUrl, addMetaToOptions  } from './helpers';
import type { QueryMetaContextValue } from 'react-query-swagger';
import { QueryMetaContext } from 'react-query-swagger';
import { useContext } from 'react';
import * as Client from './UserRolesClient'
export { Client };
import type { AxiosRequestConfig } from 'axios';

export type GetStudyRolesUserRolesQueryParameters = {
  studyId?: number | null | null;
  includeForms?: boolean | null | null;
};

    
export function getGeneralRolesUrl(): string {
  let url_ = getBaseUrl() + "/api/roles";
  url_ = url_.replace(/[?&]$/, "");
  return url_;
}

let getGeneralRolesDefaultOptions: UseQueryOptions<Types.RoleDto[], unknown, Types.RoleDto[]> = {
  queryFn: __getGeneralRoles,
};
export function getGetGeneralRolesDefaultOptions(): UseQueryOptions<Types.RoleDto[], unknown, Types.RoleDto[]> {
  return getGeneralRolesDefaultOptions;
};
export function setGetGeneralRolesDefaultOptions(options: UseQueryOptions<Types.RoleDto[], unknown, Types.RoleDto[]>) {
  getGeneralRolesDefaultOptions = options;
}

export function getGeneralRolesQueryKey(): QueryKey;
export function getGeneralRolesQueryKey(...params: any[]): QueryKey {
  return trimArrayEnd([
      'UserRolesClient',
      'getGeneralRoles',
    ]);
}
function __getGeneralRoles() {
  return Client.getGeneralRoles(
    );
}

/**
 * Returns a list of all roles with permissions
 */
export function useGetGeneralRolesQuery<TSelectData = Types.RoleDto[], TError = unknown>(options?: UseQueryOptions<Types.RoleDto[], TError, TSelectData>, axiosConfig?: Partial<AxiosRequestConfig>): UseQueryResult<TSelectData, TError>;
export function useGetGeneralRolesQuery<TSelectData = Types.RoleDto[], TError = unknown>(...params: any []): UseQueryResult<TSelectData, TError> {
  let options: UseQueryOptions<Types.RoleDto[], TError, TSelectData> | undefined = undefined;
  let axiosConfig: AxiosRequestConfig |undefined;
  

  options = params[0] as any;
  axiosConfig = params[1] as any;

  const metaContext = useContext(QueryMetaContext);
  options = addMetaToOptions(options, metaContext);
  if (axiosConfig) {
    options = options ?? { } as any;
    options!.meta = { ...options!.meta, axiosConfig };
  }

  return useQuery<Types.RoleDto[], TError, TSelectData>({
    queryFn: __getGeneralRoles,
    queryKey: getGeneralRolesQueryKey(),
    ...getGeneralRolesDefaultOptions as unknown as UseQueryOptions<Types.RoleDto[], TError, TSelectData>,
    ...options,
  });
}
/**
 * Returns a list of all roles with permissions
 */
export function setGetGeneralRolesData(queryClient: QueryClient, updater: (data: Types.RoleDto[] | undefined) => Types.RoleDto[], ) {
  queryClient.setQueryData(getGeneralRolesQueryKey(),
    updater
  );
}

/**
 * Returns a list of all roles with permissions
 */
export function setGetGeneralRolesDataByQueryId(queryClient: QueryClient, queryKey: QueryKey, updater: (data: Types.RoleDto[] | undefined) => Types.RoleDto[]) {
  queryClient.setQueryData(queryKey, updater);
}
    
    
export function createRoleUrl(): string {
  let url_ = getBaseUrl() + "/api/roles";
  url_ = url_.replace(/[?&]$/, "");
  return url_;
}

export function createRoleMutationKey(): MutationKey {
  return trimArrayEnd([
      'UserRolesClient',
      'createRole',
    ]);
}

/**
 * Create a new role
 * @param dto Creation role DTO
 * @return New role Id
 */
export function useCreateRoleMutation<TContext>(options?: Omit<UseMutationOptions<string, unknown, Types.RoleCreationDto, TContext>, 'mutationKey' | 'mutationFn'>): UseMutationResult<string, unknown, Types.RoleCreationDto, TContext> {
  const key = createRoleMutationKey();
  
  const metaContext = useContext(QueryMetaContext);
  options = addMetaToOptions(options, metaContext);
  
      return useMutation((dto: Types.RoleCreationDto) => Client.createRole(dto), {...options, mutationKey: key});
}
  
    
export function getStudyRolesUrl(studyId?: number | null | undefined, includeForms?: boolean | null | undefined): string {
  let url_ = getBaseUrl() + "/api/roles/studyRoles?";
if (studyId !== undefined && studyId !== null)
    url_ += "studyId=" + encodeURIComponent("" + studyId) + "&";
if (includeForms !== undefined && includeForms !== null)
    url_ += "includeForms=" + encodeURIComponent("" + includeForms) + "&";
  url_ = url_.replace(/[?&]$/, "");
  return url_;
}

let getStudyRolesDefaultOptions: UseQueryOptions<Types.StudyRoleDto[], unknown, Types.StudyRoleDto[]> = {
  queryFn: __getStudyRoles,
};
export function getGetStudyRolesDefaultOptions(): UseQueryOptions<Types.StudyRoleDto[], unknown, Types.StudyRoleDto[]> {
  return getStudyRolesDefaultOptions;
};
export function setGetStudyRolesDefaultOptions(options: UseQueryOptions<Types.StudyRoleDto[], unknown, Types.StudyRoleDto[]>) {
  getStudyRolesDefaultOptions = options;
}

export function getStudyRolesQueryKey(dto: GetStudyRolesUserRolesQueryParameters): QueryKey;
export function getStudyRolesQueryKey(studyId?: number | null | undefined, includeForms?: boolean | null | undefined): QueryKey;
export function getStudyRolesQueryKey(...params: any[]): QueryKey {
  if (params.length === 1 && isParameterObject(params[0])) {
    const { studyId, includeForms,  } = params[0] as GetStudyRolesUserRolesQueryParameters;

    return trimArrayEnd([
        'UserRolesClient',
        'getStudyRoles',
        studyId as any,
        includeForms as any,
      ]);
  } else {
    return trimArrayEnd([
        'UserRolesClient',
        'getStudyRoles',
        ...params
      ]);
  }
}
function __getStudyRoles(context: QueryFunctionContext) {
  return Client.getStudyRoles(
      context.queryKey[2] as number | null | undefined,       context.queryKey[3] as boolean | null | undefined    );
}

export function useGetStudyRolesQuery<TSelectData = Types.StudyRoleDto[], TError = unknown>(dto: GetStudyRolesUserRolesQueryParameters, options?: UseQueryOptions<Types.StudyRoleDto[], TError, TSelectData>, axiosConfig?: Partial<AxiosRequestConfig>): UseQueryResult<TSelectData, TError>;
/**
 * Returns a list of all study roles with claims
 * @param studyId (optional) 
 * @param includeForms (optional) 
 */
export function useGetStudyRolesQuery<TSelectData = Types.StudyRoleDto[], TError = unknown>(studyId?: number | null | undefined, includeForms?: boolean | null | undefined, options?: UseQueryOptions<Types.StudyRoleDto[], TError, TSelectData>, axiosConfig?: Partial<AxiosRequestConfig>): UseQueryResult<TSelectData, TError>;
export function useGetStudyRolesQuery<TSelectData = Types.StudyRoleDto[], TError = unknown>(...params: any []): UseQueryResult<TSelectData, TError> {
  let options: UseQueryOptions<Types.StudyRoleDto[], TError, TSelectData> | undefined = undefined;
  let axiosConfig: AxiosRequestConfig |undefined;
  let studyId: any = undefined;
  let includeForms: any = undefined;
  
  if (params.length > 0) {
    if (isParameterObject(params[0])) {
      ({ studyId, includeForms,  } = params[0] as GetStudyRolesUserRolesQueryParameters);
      options = params[1];
      axiosConfig = params[2];
    } else {
      [studyId, includeForms, options, axiosConfig] = params;
    }
  }

  const metaContext = useContext(QueryMetaContext);
  options = addMetaToOptions(options, metaContext);
  if (axiosConfig) {
    options = options ?? { } as any;
    options!.meta = { ...options!.meta, axiosConfig };
  }

  return useQuery<Types.StudyRoleDto[], TError, TSelectData>({
    queryFn: __getStudyRoles,
    queryKey: getStudyRolesQueryKey(studyId, includeForms),
    ...getStudyRolesDefaultOptions as unknown as UseQueryOptions<Types.StudyRoleDto[], TError, TSelectData>,
    ...options,
  });
}
/**
 * Returns a list of all study roles with claims
 * @param studyId (optional) 
 * @param includeForms (optional) 
 */
export function setGetStudyRolesData(queryClient: QueryClient, updater: (data: Types.StudyRoleDto[] | undefined) => Types.StudyRoleDto[], studyId?: number | null | undefined, includeForms?: boolean | null | undefined) {
  queryClient.setQueryData(getStudyRolesQueryKey(studyId, includeForms),
    updater
  );
}

/**
 * Returns a list of all study roles with claims
 * @param studyId (optional) 
 * @param includeForms (optional) 
 */
export function setGetStudyRolesDataByQueryId(queryClient: QueryClient, queryKey: QueryKey, updater: (data: Types.StudyRoleDto[] | undefined) => Types.StudyRoleDto[]) {
  queryClient.setQueryData(queryKey, updater);
}
    
    
export function createStudyRoleUrl(): string {
  let url_ = getBaseUrl() + "/api/roles/studyRoles";
  url_ = url_.replace(/[?&]$/, "");
  return url_;
}

export function createStudyRoleMutationKey(): MutationKey {
  return trimArrayEnd([
      'UserRolesClient',
      'createStudyRole',
    ]);
}

/**
 * Create a new study role
 * @param dto Creation role DTO
 */
export function useCreateStudyRoleMutation<TContext>(options?: Omit<UseMutationOptions<void, unknown, Types.StudyRoleCreationDto, TContext>, 'mutationKey' | 'mutationFn'>): UseMutationResult<void, unknown, Types.StudyRoleCreationDto, TContext> {
  const key = createStudyRoleMutationKey();
  
  const metaContext = useContext(QueryMetaContext);
  options = addMetaToOptions(options, metaContext);
  
      return useMutation((dto: Types.StudyRoleCreationDto) => Client.createStudyRole(dto), {...options, mutationKey: key});
}
  
    
export function addStudyClaimsToRoleUrl(roleId: string): string {
  let url_ = getBaseUrl() + "/api/roles/studyRoles/{roleId}/claims/add";
if (roleId === undefined || roleId === null)
  throw new Error("The parameter 'roleId' must be defined.");
url_ = url_.replace("{roleId}", encodeURIComponent("" + roleId));
  url_ = url_.replace(/[?&]$/, "");
  return url_;
}

export function addStudyClaimsToRoleMutationKey(roleId: string): MutationKey {
  return trimArrayEnd([
      'UserRolesClient',
      'addStudyClaimsToRole',
      roleId as any,
    ]);
}

/**
 * Add claims to the study role
 * @param roleId Study Role Id to add new claims
 * @param claims Claims to add
 */
export function useAddStudyClaimsToRoleMutation<TContext>(roleId: string, options?: Omit<UseMutationOptions<void, unknown, Types.StudyRoleClaimValue[], TContext>, 'mutationKey' | 'mutationFn'>): UseMutationResult<void, unknown, Types.StudyRoleClaimValue[], TContext> {
  const key = addStudyClaimsToRoleMutationKey(roleId);
  
  const metaContext = useContext(QueryMetaContext);
  options = addMetaToOptions(options, metaContext);
  
      return useMutation((claims: Types.StudyRoleClaimValue[]) => Client.addStudyClaimsToRole(roleId, claims), {...options, mutationKey: key});
}
  
    
export function makeFormAvailableToRoleUrl(roleId: string, formConfigId?: number | undefined): string {
  let url_ = getBaseUrl() + "/api/roles/studyRoles/{roleId}/availableForms/add?";
if (roleId === undefined || roleId === null)
  throw new Error("The parameter 'roleId' must be defined.");
url_ = url_.replace("{roleId}", encodeURIComponent("" + roleId));
if (formConfigId === null)
    throw new Error("The parameter 'formConfigId' cannot be null.");
else if (formConfigId !== undefined)
    url_ += "formConfigId=" + encodeURIComponent("" + formConfigId) + "&";
  url_ = url_.replace(/[?&]$/, "");
  return url_;
}

export function makeFormAvailableToRoleMutationKey(roleId: string, formConfigId?: number | undefined): MutationKey {
  return trimArrayEnd([
      'UserRolesClient',
      'makeFormAvailableToRole',
      roleId as any,
      formConfigId as any,
    ]);
}

/**
 * Make form config available to role
 * @param roleId Role Id to add new forms
 * @param formConfigId (optional) Form config id to make available
 */
export function useMakeFormAvailableToRoleMutation<TContext>(roleId: string, formConfigId?: number | undefined, options?: Omit<UseMutationOptions<void, unknown, void, TContext>, 'mutationKey' | 'mutationFn'>): UseMutationResult<void, unknown, void, TContext> {
  const key = makeFormAvailableToRoleMutationKey(roleId, formConfigId);
  
  const metaContext = useContext(QueryMetaContext);
  options = addMetaToOptions(options, metaContext);
  
      return useMutation(() => Client.makeFormAvailableToRole(roleId, formConfigId), {...options, mutationKey: key});
}
  
    
export function makeFormUnavailableToRoleUrl(roleId: string, formConfigId?: number | undefined): string {
  let url_ = getBaseUrl() + "/api/roles/studyRoles/{roleId}/availableForms/remove?";
if (roleId === undefined || roleId === null)
  throw new Error("The parameter 'roleId' must be defined.");
url_ = url_.replace("{roleId}", encodeURIComponent("" + roleId));
if (formConfigId === null)
    throw new Error("The parameter 'formConfigId' cannot be null.");
else if (formConfigId !== undefined)
    url_ += "formConfigId=" + encodeURIComponent("" + formConfigId) + "&";
  url_ = url_.replace(/[?&]$/, "");
  return url_;
}

export function makeFormUnavailableToRoleMutationKey(roleId: string, formConfigId?: number | undefined): MutationKey {
  return trimArrayEnd([
      'UserRolesClient',
      'makeFormUnavailableToRole',
      roleId as any,
      formConfigId as any,
    ]);
}

/**
 * Make form config unavailable to role
 * @param roleId Role Id to add new forms
 * @param formConfigId (optional) Form config id to make unavailable
 */
export function useMakeFormUnavailableToRoleMutation<TContext>(roleId: string, formConfigId?: number | undefined, options?: Omit<UseMutationOptions<void, unknown, void, TContext>, 'mutationKey' | 'mutationFn'>): UseMutationResult<void, unknown, void, TContext> {
  const key = makeFormUnavailableToRoleMutationKey(roleId, formConfigId);
  
  const metaContext = useContext(QueryMetaContext);
  options = addMetaToOptions(options, metaContext);
  
      return useMutation(() => Client.makeFormUnavailableToRole(roleId, formConfigId), {...options, mutationKey: key});
}
  
    
export function removeStudyRoleUrl(id: string): string {
  let url_ = getBaseUrl() + "/api/roles/studyRoles/{id}";
if (id === undefined || id === null)
  throw new Error("The parameter 'id' must be defined.");
url_ = url_.replace("{id}", encodeURIComponent("" + id));
  url_ = url_.replace(/[?&]$/, "");
  return url_;
}

export function removeStudyRoleMutationKey(id: string): MutationKey {
  return trimArrayEnd([
      'UserRolesClient',
      'removeStudyRole',
      id as any,
    ]);
}

/**
 * Remove study role
 * @param id Id of the role to be removed
 */
export function useRemoveStudyRoleMutation<TContext>(id: string, options?: Omit<UseMutationOptions<void, unknown, void, TContext>, 'mutationKey' | 'mutationFn'>): UseMutationResult<void, unknown, void, TContext> {
  const key = removeStudyRoleMutationKey(id);
  
  const metaContext = useContext(QueryMetaContext);
  options = addMetaToOptions(options, metaContext);
  
      return useMutation(() => Client.removeStudyRole(id), {...options, mutationKey: key});
}
  
    
export function removeStudyClaimsFromRoleUrl(roleId: string): string {
  let url_ = getBaseUrl() + "/api/roles/studyRoles/{roleId}/claims/remove";
if (roleId === undefined || roleId === null)
  throw new Error("The parameter 'roleId' must be defined.");
url_ = url_.replace("{roleId}", encodeURIComponent("" + roleId));
  url_ = url_.replace(/[?&]$/, "");
  return url_;
}

export function removeStudyClaimsFromRoleMutationKey(roleId: string): MutationKey {
  return trimArrayEnd([
      'UserRolesClient',
      'removeStudyClaimsFromRole',
      roleId as any,
    ]);
}

/**
 * Remove claims from the study role
 * @param roleId Study Role Id to remove new claims
 * @param claims Claims to add
 */
export function useRemoveStudyClaimsFromRoleMutation<TContext>(roleId: string, options?: Omit<UseMutationOptions<void, unknown, Types.StudyRoleClaimValue[], TContext>, 'mutationKey' | 'mutationFn'>): UseMutationResult<void, unknown, Types.StudyRoleClaimValue[], TContext> {
  const key = removeStudyClaimsFromRoleMutationKey(roleId);
  
  const metaContext = useContext(QueryMetaContext);
  options = addMetaToOptions(options, metaContext);
  
      return useMutation((claims: Types.StudyRoleClaimValue[]) => Client.removeStudyClaimsFromRole(roleId, claims), {...options, mutationKey: key});
}
  
    
export function removeRoleUrl(id: string): string {
  let url_ = getBaseUrl() + "/api/roles/{id}";
if (id === undefined || id === null)
  throw new Error("The parameter 'id' must be defined.");
url_ = url_.replace("{id}", encodeURIComponent("" + id));
  url_ = url_.replace(/[?&]$/, "");
  return url_;
}

export function removeRoleMutationKey(id: string): MutationKey {
  return trimArrayEnd([
      'UserRolesClient',
      'removeRole',
      id as any,
    ]);
}

/**
 * Remove role
 * @param id Id of the role to be removed
 */
export function useRemoveRoleMutation<TContext>(id: string, options?: Omit<UseMutationOptions<void, unknown, void, TContext>, 'mutationKey' | 'mutationFn'>): UseMutationResult<void, unknown, void, TContext> {
  const key = removeRoleMutationKey(id);
  
  const metaContext = useContext(QueryMetaContext);
  options = addMetaToOptions(options, metaContext);
  
      return useMutation(() => Client.removeRole(id), {...options, mutationKey: key});
}
  
    
export function addPermissionUrl(roleId: string, permission?: Types.Permissions | undefined): string {
  let url_ = getBaseUrl() + "/api/roles/permissions/{roleId}/add?";
if (roleId === undefined || roleId === null)
  throw new Error("The parameter 'roleId' must be defined.");
url_ = url_.replace("{roleId}", encodeURIComponent("" + roleId));
if (permission === null)
    throw new Error("The parameter 'permission' cannot be null.");
else if (permission !== undefined)
    url_ += "permission=" + encodeURIComponent("" + permission) + "&";
  url_ = url_.replace(/[?&]$/, "");
  return url_;
}

export function addPermissionMutationKey(roleId: string, permission?: Types.Permissions | undefined): MutationKey {
  return trimArrayEnd([
      'UserRolesClient',
      'addPermission',
      roleId as any,
      permission as any,
    ]);
}

/**
 * Add permission to the role
 * @param roleId Role Id to add new permission
 * @param permission (optional) Permission to add
 */
export function useAddPermissionMutation<TContext>(roleId: string, permission?: Types.Permissions | undefined, options?: Omit<UseMutationOptions<void, unknown, void, TContext>, 'mutationKey' | 'mutationFn'>): UseMutationResult<void, unknown, void, TContext> {
  const key = addPermissionMutationKey(roleId, permission);
  
  const metaContext = useContext(QueryMetaContext);
  options = addMetaToOptions(options, metaContext);
  
      return useMutation(() => Client.addPermission(roleId, permission), {...options, mutationKey: key});
}
  
    
export function removePermissionUrl(roleId: string, permission?: Types.Permissions | undefined): string {
  let url_ = getBaseUrl() + "/api/roles/permissions/{roleId}/remove?";
if (roleId === undefined || roleId === null)
  throw new Error("The parameter 'roleId' must be defined.");
url_ = url_.replace("{roleId}", encodeURIComponent("" + roleId));
if (permission === null)
    throw new Error("The parameter 'permission' cannot be null.");
else if (permission !== undefined)
    url_ += "permission=" + encodeURIComponent("" + permission) + "&";
  url_ = url_.replace(/[?&]$/, "");
  return url_;
}

export function removePermissionMutationKey(roleId: string, permission?: Types.Permissions | undefined): MutationKey {
  return trimArrayEnd([
      'UserRolesClient',
      'removePermission',
      roleId as any,
      permission as any,
    ]);
}

/**
 * Remove permission from the role
 * @param roleId Role Id to remove the permission
 * @param permission (optional) Permission to remove
 */
export function useRemovePermissionMutation<TContext>(roleId: string, permission?: Types.Permissions | undefined, options?: Omit<UseMutationOptions<void, unknown, void, TContext>, 'mutationKey' | 'mutationFn'>): UseMutationResult<void, unknown, void, TContext> {
  const key = removePermissionMutationKey(roleId, permission);
  
  const metaContext = useContext(QueryMetaContext);
  options = addMetaToOptions(options, metaContext);
  
      return useMutation(() => Client.removePermission(roleId, permission), {...options, mutationKey: key});
}